export const RECAPTCHA_SITE_KEY = String(process.env.RECAPTCHA_SITE_KEY)
export const API_URL = String(process.env.API_URL)
